export default (angle: number) => {
  return (angle / 90 - Math.floor(angle / 90)) * 90;
};
